<template>
  <div :class="['ms-form', 'ms-form--narrow', {purpose: this.data?.body?.purpose}]">
    <q-form @submit="this.onSubmit">
      <div class="ms-form-grid ms-form-grid--single">
        <div>
          <CustomSelect
              :options="this.docTypes"
              :required="true"
              label="Тип документа"
              optionValueKey="document_type_id"
              optionLabelKey="document_type_name"
              :value="this.formData.document_type_id || ''"
              :loading="this.loading"
              :disabled="this.loading"
              @change="(value) => onChange('document_type_id', value, true)"
          />
        </div>
        <template v-if="this.selectedDocType === 'ADJUSTMENT'">
          <div>
            <CustomSelect
                :options="this.approveDocTypes"
                :required="true"
                label="Тип согласования"
                optionValueKey="approve_document_type_id"
                optionLabelKey="approve_document_type_name"
                :value="this.formData.approve_document_type_id || ''"
                @change="(value) => onChange('approve_document_type_id', value)"
            />
          </div>
        </template>
        <template v-if="this.selectedDocType === 'DRAFT_ACCEPT_ACT'">
          <div>
            <CustomDate
                :required="true"
                placeholder="Дата подписания акта приема-передачи ЧО"
                :value="this.formData.draft_akt_date || ''"
                @change_date="(value) => onChange('draft_akt_date', value)"
            />
          </div>
        </template>
        <template v-if="this.selectedDocType === 'APART_PASS_ACT_CL'">
          <div>
            <CustomDate
                :required="true"
                :fullWidth="true"
                placeholder="Дата реализации (для бухгалтерии)"
                :value="this.formData.implementation_date || ''"
                @change_date="(value) => onChange('implementation_date', value)"
            />
          </div>
          <div>
            <CustomCheckbox
                label="Односторонний акт"
                :value="this.formData.unilateral_act"
                @change="(value) => onChange('unilateral_act', value)"
            />
          </div>
        </template>
        <template v-if="this.selectedDocType === 'ADDITIONAL_AGREEMENT'">
          <div>
            <CustomSelect
                :options="this.dsTypes"
                :required="true"
                label="Тип ДС"
                optionValueKey="ds_type_id"
                optionLabelKey="ds_type_name"
                :value="this.formData.ds_type_id || ''"
                @change="(value) => onChange('ds_type_id', value)"
            />
          </div>
          <div>
            <CustomInput
                label="Номер ДС"
                :required="true"
                :value="this.formData.document_num"
                @change_input="(value) => onChange('document_num', value)"
            />
          </div>
          <div>
            <CustomDate
                :required="true"
                placeholder="Дата ДС"
                :value="this.formData.document_date || ''"
                @change_date="(value) => onChange('document_date', value)"
            />
          </div>
          <div>
            <CustomInput
                label="Сумма ДС"
                :required="true" type="number"
                :value="this.formData.additional_agreement_amount"
                @change_input="(value) => onChange('additional_agreement_amount', value)"
            />
          </div>
        </template>
        <div v-if="this.data?.body?.document_url">
          <span class="ms-form-label doc-file__label">Загруженный файл</span>
          <div class="doc-file">
            <Clickable link :href="getFullUrl(this.data?.body?.document_url)">{{ this.data?.body?.document_name }}
              <q-icon name="download"/>
            </Clickable>
          </div>
        </div>
        <div>
          <CustomUploader :value="this.formData?.document"
                          :on-change="(value) => this.onChange('document', value)" label="Файл"/>
        </div>
      </div>
      <CustomModalFooter :btn-loading="this.loading"/>
    </q-form>
  </div>
</template>
<script>

import CustomModalFooter from "@/components/modal/modals/modal-footer";
import CustomSelect from "@/components/form/CustomSelect";
import CustomUploader from "@/components/form/CustomUploader";
import {appActionTypes} from "@/services/store/modules/app_module/app_mutation_types";
import Clickable from "@/components/common/Clickable";
import {getFullUrl} from "@/services";
import CustomInput from "@/components/form/CustomInput";
import CustomDate from "@/components/form/CustomDate";
import CustomCheckbox from "@/components/form/CustomCheckbox";
import {getApproveDocTypes, getDocModalBody, getDSTypesByDocs} from "@/views/ClientRequests/remontDocs/services";

export default {
  name: "add-doc",
  components: {
    CustomCheckbox,
    CustomDate,
    CustomInput,
    Clickable,
    CustomUploader,
    CustomSelect,
    CustomModalFooter
  },
  props: ['data'],
  data() {
    return {
      loading: false,
      selectedDocType: this.data?.document_type_code ||'',
      dsTypes: [],
      approveDocTypes: [],
      formData: {
        document_type_id: this.data?.body?.document_type_id || '',
        document: '',
        ds_type_id: this.data?.body?.ds_type_id || '',
        document_num: this.data?.body?.document_num || '',
        document_date: this.data?.body?.document_date || '',
        additional_agreement_amount: this.data?.body?.additional_agreement_amount || '',
        client_receive_date: this.data?.body?.client_receive_date || '',
        implementation_date: this.data?.body?.implementation_date || '',
        unilateral_act: this.data?.body?.unilateral_act || false,
        draft_akt_date: this.data?.body?.draft_akt_date || '',
        approve_document_type_id: this.data?.body?.approve_document_type_id || '',
      }
    }
  },
  methods: {
    getFullUrl,
    resolveDocTypeCode(value) {
      const selected = (this.docTypes || []).find((item) => String(item.document_type_id) === String(value))
      return selected?.type_code || ''
    },
    async onChange(key, value, is_doc_type) {
      if (this.loading) return
      if (is_doc_type) {
        const docType = this.resolveDocTypeCode(value)
        this.selectedDocType = docType
        this.formData[key] = value
        if (docType === 'APART_PASS_ACT_CL' && this.data?.onAppSelected && !this.data?.skipAppReviewGate) {
          this.loading = true
          try {
            const allowed = await this.data.onAppSelected(value, {...this.formData})
            if (allowed === false) {
              this.selectedDocType = ''
              this.formData.document_type_id = ''
            }
          } finally {
            this.loading = false
          }
          return
        }
        if(docType === 'ADDITIONAL_AGREEMENT') {
          this.getDSTypes()
        }
        if(docType === 'ADJUSTMENT') {
          this.getApproveTypes()
        }
        return
      }
      this.formData[key] = value
    },
    async onSubmit() {
      const formData = getDocModalBody(this.formData, this.selectedDocType)
      this.loading = true
      await this.data?.onSubmit(formData, this.selectedDocType)
      this.loading = false
    },
    async getDSTypes() {
      if(this.dsTypes?.length) return
      const res = await getDSTypesByDocs()
      this.dsTypes = res || []
    },
    async getApproveTypes() {
      if(this.approveDocTypes?.length) return
      const res = await getApproveDocTypes()
      this.approveDocTypes = res || []
    }
  },
  computed: {
    docTypes() {
      return this.$store.state.app.docTypes;
    },
  },
  mounted() {
    this.$store.dispatch(appActionTypes.getDocTypes)
  },
}
</script>

<style scoped lang="scss">
// Сетка — общая (ms-form-* в theme.scss)
.doc-file {
  padding: 10px 12px;
  border-radius: var(--ms-radius-sm);
  border: 1px solid var(--ms-border-input);
  color: var(--ms-primary);

  &__label {
    display: block;
  }
}
</style>
